// Header.js
import React from "react";
import { Bell } from "lucide-react";
import { useNavigate } from "react-router-dom";

const Header = ({ userData }) => {
  const navigate = useNavigate();

  // ❗ Only show header text if userData is available
  const shouldShowGreeting = !!userData?.fullName;

  return (
    <div className="mb-6 relative">
      {/* Floating Notification Bell */}
      <div className="absolute top-0 right-0 z-10">
        <button
          onClick={() => navigate("/notifications")}
          className="text-gray-700 hover:text-blue-600 transition"
          aria-label="Notifications"
        >
          <Bell size={28} />
        </button>
      </div>

      {/* Conditionally show welcome text */}
      {shouldShowGreeting && (
        <div>
          <h1 className="text-2xl font-semibold">
            👑 Welcome back, {userData.fullName}
          </h1>
          <p className="text-gray-600">
            You’re part of something powerful — let’s fund the future together 🚀
          </p>
        </div>
      )}
    </div>
  );
};

export default Header;
